import { Product, Map, ProductUpdate, Field, ProductFilter } from "typings/index";
import { ApiBase } from "./ApiBase";

export class ProductAPI extends ApiBase
{
    fetchAll(): Promise<Product[]>
    {
        return this.get<Product[]>("frontend/product");
    }

    fetchOne(id: string): Promise<Product>
    {
        return this.get<Product>(`frontend/product/${id}`);
    }

    async clearProductField(productId: string, fieldName: string): Promise<Product> 
    {
        const result = await this.fetch(`frontend/product/${productId}/${fieldName}`,
        {
            method: "DELETE",
        });
        return result.json();
    }

    async createMainProduct(children: string[], name: string, templateId: string): Promise<Product[]>
    {
        return this.fetchAsync("PUT", `frontend/product/create`, { children, name, templateId });
    }

    async update(productId: string, update: ProductUpdate) : Promise<Product>
    {
        return this.fetchAsync("POST", `frontend/product/${productId}/`, update);
    }

    async delete(productId: string): Promise<Product>
    {
        return this.fetchAsync("DELETE", `frontend/product/${productId}/`);
    }

    async updateParent(parentId: string, ids: string[]): Promise<void>
    {
        return this.fetchAsync("POST", `frontend/product/updateParent/`, { parentId, ids });
    }

    async updateMultiple(ids: string[], update: ProductUpdate) : Promise<Product[]>
    {
        return this.fetchAsync("POST", `frontend/product/updateMultiple/`, { ...update, ids });
    }

    async updateData(id: string, update: { [key: string]: any}): Promise<Product>
    {
        return this.fetchAsync("POST", `frontend/product/${id}/data`, update);
    }

    fetchFieldData(url: string): Promise<string[]>
    {
        return this.get<string[]>(url);
    }

    fetchFieldTranslations(url: string, language: string): Promise<Map<string>>
    {
        return this.get<Map<string>>(`${url}${language}`);
    }

    getFields(): Promise<Field[]>
    {
        return this.get<Field[]>(`frontend/Field/fields`);
    }

    async updateFieldTranslations(url: string, language: string, key: string, value: string): Promise<void>
    {
        await this.fetch(`${url}${language}/${key}/${value}`,
        {
            method: "PUT"
        });
    }

 

    async fetchProducts(filter: ProductFilter):Promise<{ products:Product[], pages: number }>
    {
        return this.fetchAsync("POST", `frontend/product/filter`, filter);
    }

    async getProducts(products: string[]):Promise<Product[]>
    {
        return this.fetchAsync("POST", `frontend/product/products`, products);
    }
}


// WEBPACK FOOTER //
// ./src/services/product.ts